/* ============================================================
   Custom image sidebar / drawer menu
   Pair with: snippets/custom-menu-drawer.liquid + custom-menu-drawer.css
   ============================================================ */
(function () {
  var drawer = document.querySelector('[data-cmd-drawer]');
  var overlay = document.querySelector('[data-cmd-overlay]');
  if (!drawer || !overlay) return;

  var lastFocused = null;
  // The header section has z-index:3 but the announcement bar has z-index:4, so the
  // drawer (inside the header) is capped below it. Lift the header while the drawer is open.
  var headerSection = document.querySelector('.section-header');
  function elevateHeader(on) { if (headerSection) headerSection.style.zIndex = on ? '1000' : ''; }

  function closeAllSubs() {
    drawer.querySelectorAll('.cmd-submenu.is-open').forEach(function (s) {
      s.classList.remove('is-open');
      s.setAttribute('aria-hidden', 'true');
    });
  }

  function openDrawer() {
    lastFocused = document.activeElement;
    elevateHeader(true);
    overlay.hidden = false;
    // next frame so the transition runs
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cmd-no-scroll');
    drawer.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cmd-no-scroll');
    closeAllSubs();
    window.setTimeout(function () { overlay.hidden = true; elevateHeader(false); }, 320);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  // triggers (your hamburger -> add data-cmd-trigger). Toggles open/closed.
  document.querySelectorAll('[data-cmd-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (drawer.classList.contains('is-open')) closeDrawer(); else openDrawer();
    });
  });

  overlay.addEventListener('click', closeDrawer);
  drawer.querySelectorAll('[data-cmd-close]').forEach(function (b) {
    b.addEventListener('click', closeDrawer);
  });

  // open a submenu panel
  drawer.querySelectorAll('[data-cmd-open-sub]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-cmd-open-sub');
      var sub = drawer.querySelector('[data-cmd-sub="' + id + '"]');
      if (sub) {
        sub.classList.add('is-open');
        sub.setAttribute('aria-hidden', 'false');
        sub.scrollTop = 0;
      }
    });
  });

  // back button -> close the current submenu
  drawer.querySelectorAll('[data-cmd-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = btn.closest('.cmd-submenu');
      if (sub) {
        sub.classList.remove('is-open');
        sub.setAttribute('aria-hidden', 'true');
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
})();
